import { Bluex, Greenx, Spacing } from "@bonusx-global/bx-design-system";
import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import { useSurveyPercentage } from "../hooks/use-survey-percentage";

export const PROGRESS_BAR_HEIGHT = Spacing["500"];

const ProgressBarBackground = styled(Box)({
  background: Bluex["50"],
  width: "100%",
  height: PROGRESS_BAR_HEIGHT,
});

const ProgressBarFiller = styled(Box)({
  background: Greenx["200"],
  height: Spacing["500"],
  transition: "width 300ms ease-in-out",
  willChange: "width",
});

export function SurveyHeaderProgressBar() {
  const { progressPercentage } = useSurveyPercentage();

  return (
    <ProgressBarBackground>
      <ProgressBarFiller style={{ width: `${progressPercentage}%` }} />
    </ProgressBarBackground>
  );
}
